window.vm = {}
window.addClickCounter = 0;

window.addEventListener('DOMContentLoaded', () => {

  if (window.location.hash.substr(1) == "cart")
	{
      document.querySelector('body').classList.add('open-cart');
	}

  (function() {
    // Observe for changes in PDP - Add to Cart
    const addToCartBttn = document.getElementById('add');
    if(addToCartBttn){
      addToCartBttn.addEventListener('click', (event) => { window.addClickCounter = window.addClickCounter + 1; });
      let mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {          
          if (!mutation.target.disabled) {
            globalCart.fetchCartData();
            if (window.addClickCounter > 0)
              {
                document.querySelector('.cart-link__bttn').click();
                window.addClickCounter = 0;
              }            
          }
        });
      });

      const mutationAttr = {
        attributes: true,
        characterData: true
      };

      mutationObserver.observe(addToCartBttn, mutationAttr);
    }
    
    //Observe for changes in Collection Quick Add
   	const buttons = document.getElementsByClassName('quick-add-button');
    Array.from(buttons).forEach((addButton) => {
      let mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (!mutation.target.disabled) {
            globalCart.fetchCartData();
            document.querySelector('.cart-link__bttn').click();
          }
        });
      });

      const mutationAttr = {
        attributes: true,
        characterData: true
      };

      mutationObserver.observe(addButton, mutationAttr);
    });
  })();

  const globalCart = new Vue({
    el: '.global-cart',
    delimiters: ['${', '}'],
    data: {
      cartData: null,
      cartOpen: document.querySelector('body').classList.contains('open-cart'),
      oregonOnly: null,
      isBadgeSet: false,
      giftNote: null,
      hasClubProducts: false,
      hasNonClubProducts: false,
      hasGiftSubscriptions: false,
      hasNonGiftSubscriptions: false,
      feeVariantId: 49771255824612,
      busy: false
    },
    mounted() {
      if (this.get_cookie('clear_cart'))
      {
         this.clearCart();
         this.delete_cookie('clear_cart','/','westwardwhiskey.com');
      }
      else
      {
        this.fetchCartData();  
      }
      
      if (sessionStorage.oregonOnly != null)
      {
        this.oregonOnly = sessionStorage.oregonOnly == "true";
        this.isBadgeSet = true;
      }
      vm.cart = this;
    },
/*    watch: {
      oregonOnly(val, oldVal) {
        if (this.loadedDefaults == true)
        {
          console.log('changed',val,this.oregonOnly);
          sessionStorage.oregonOnly = val;
          this.isBadgeSet = true;
        }
      }
    },
*/
    methods: {
      fetchCartData() {
        fetch('/cart.js')
          .then((res) => res.json())
          .then(async (data) => {
          	await this.updateItemTags(data);
            // Keep the membership fee item in sync with the club subscription before rendering.
            // reconcileFeeItem triggers another fetchCartData, so leave `busy` set for it to clear.
            if (await this.reconcileFeeItem(data)) { return; }
            this.updateCartCount(data.item_count);
            this.cartData = data;
            this.hasClubProducts = data.items.filter(i => this.isClubItem(i)).length > 0;
            this.hasNonClubProducts = data.items.filter(i => !this.isClubItem(i) && !this.isFeeItem(i)).length > 0;
            this.hasGiftSubscriptions = data.items.filter(i => i.tags.includes('gift-subscription')).length > 0;
            this.hasNonGiftSubscriptions = data.items.filter(i => !i.tags.includes('gift-subscription') && !this.isFeeItem(i)).length > 0;
            this.busy = false;
          })
          .catch((error) => {
            console.log('ERROR:', error.message);
            this.busy = false;
          });
      },
      changeLine(id, qty) {
        this.busy = true;
        const body = {
          id: id.toString(),
          quantity: qty
        };
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        };

        fetch('/cart/change.js', config)
          .then((res) => res.json())
          .then((data) => {
            this.fetchCartData();
            //this.cartData = data;
            //this.updateCartCount(data.item_count);
          })
          .catch((error) => {
            const errorMessage = error.message;
            console.log('ERROR:', errorMessage);
            this.busy = false;
          });
      },
      clearCart() {
        this.busy = true;
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        };

        fetch('/cart/clear.js', config)
          .then((res) => res.json())
          .then((data) => {
            this.fetchCartData();
          })
          .catch((error) => {
            const errorMessage = error.message;
            console.log('ERROR:', errorMessage);
            this.busy = false;
          });
      },
      updateCartCount(count){
        const cartCount = document.querySelector('.cart__count');
        if (cartCount)
        {
        	cartCount.innerText = `(${count})`;
        }
      },
    isOregonOnly(flag) {
      this.oregonOnly = flag;
      sessionStorage.oregonOnly = this.oregonOnly;
      this.isBadgeSet = true;
    },
    onBadgeSwitch(event) {
      this.oregonOnly = event.target.checked;
      sessionStorage.oregonOnly = this.oregonOnly;
      this.isBadgeSet = true;
    },
    get_cookie(name){
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
  },
  delete_cookie(name, path, domain) {
  if( this.get_cookie(name) ) {    
    document.cookie = name + "=" +
      ((path) ? ";path="+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
  },
    async checkout(domain,customer_id,customer_email) {
    	let baseURL = "https://westward-whiskey-nation.myshopify.com";
    	if (!this.oregonOnly && !this.hasClubProducts && !this.hasGiftSubscriptions)
    	{
    		const cartItems = this.cartData.items.filter(i => i.tags.includes('B:SS'));
    		let cartParams = new Array();            
            cartItems.forEach(item => {
    			let cartItem = {};
    			cartItem.id = item.tags.filter(t => t.includes('WW:'))[0].split(':')[1];
				cartItem.quantity = item.quantity;
    			let sp = item.tags.filter(t => t.includes('SP:'));
    			if (sp.length > 0)
   				{
    				cartItem.selling_plan = sp[0].split(':')[1];
                  	cartItem.quantity = 1;
  				}
    			cartParams.push(cartItem);
          	});
			
			// let data = { items: cartParams };
			// if (this.giftNote != null)
      //       {
      //       	data.note = this.giftNote;
      //       }
			//window.location.href = baseURL + "/pages/cart?add=" + encodeURIComponent(JSON.stringify(data));
			let productString = cartParams.map(product => `${product.id}:${product.quantity}`).join(',');
      let noteParam = "";
      if (this.giftNote != null)
      {
        noteParam = `?note=`+ encodeURIComponent(this.giftNote);
      }
			window.location.href = baseURL + "/cart/" + productString + noteParam;

  		}
    	else
    	{
  		var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];      	
        let excludedIds = this.cartData.items.filter(i => i.tags.includes('B:SS') && !i.tags.includes('B:OO')).map(i => i.variant_id);                    
        if (!this.oregonOnly)
        {
          	excludedIds = this.cartData.items.filter(i => !(this.isClubItem(i) || i.tags.includes('gift-subscription') || this.isFeeItem(i))).map(i => i.variant_id);
            // const giftIds = this.cartData.items.filter(i => !i.tags.includes('gift-subscription')).map(i => i.variant_id);
            // if (giftIds && giftIds.length > 0)
            //   {
            //     if (excludedIds)
            //       {
            //         excludedIds = [...excludedIds, ...giftIds];
            //       }
            //       else
            //       {
            //         excludedIds = giftIds;
            //       }
            //   }
        }
        if (excludedIds && excludedIds.length) {
           await this.asyncForEach(excludedIds, async id => {
          	  await fetch('/cart/change.js', {
                method: 'POST',
                headers: {                  
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({id: id.toString(), quantity: 0})
              });
          });
          }
          
          var paramNote = this.giftNote != null ? `?note=${encodeURIComponent(this.giftNote)}` : '';
          window.location = '/checkout' + paramNote;
		}
  	},
      isFeeItem(item) {
        return !!item && item.variant_id === this.feeVariantId;
      },
      // A club membership is a Recharge subscription line (tag `recharge-subscription-product`),
      // NOT any product with "club" in its handle (club-branded bottles share that word).
      // The fee line is excluded so reconcileFeeItem can still remove it once the membership leaves.
      isClubItem(item) {
        return !!item && !this.isFeeItem(item) &&
          !!item.tags && item.tags.includes('recharge-subscription-product');
      },
      // Ensures the (irremovable) membership fee item mirrors the club subscription:
      // added whenever a club membership item is present, removed once no club item remains.
      // Returns true when it changed the cart (a fresh fetchCartData was triggered).
      async reconcileFeeItem(data) {
        if (!data || !data.items) { return false; }
        const hasClub = data.items.some(i => this.isClubItem(i));
        const feeLine = data.items.find(i => this.isFeeItem(i));
        if (hasClub && !feeLine) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: this.feeVariantId, quantity: 1 })
          });
          this.fetchCartData();
          return true;
        }
        if (!hasClub && feeLine) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: feeLine.key || feeLine.id.toString(), quantity: 0 })
          });
          this.fetchCartData();
          return true;
        }
        return false;
      },
      async updateItemTags(data) {
        if (data && data.items) {
          // Fetch every line item's tags concurrently instead of one-at-a-time —
          // the sequential version was the main source of the cart's lag.
          await Promise.all(data.items.map(async (item) => {
            const product = await fetch(`/products/${item.handle}.js`).then((res) => res.json());
            item.tags = product.tags;
          }));
        }
      },
      async asyncForEach(array, callback) {
        for (let index = 0; index < array.length; index++) {
          await callback(array[index], index, array);
        }
      }
    },
    filters: {
      formatPrice(price) {
        return (price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      resizeImg(src) {
        const n = src?.lastIndexOf('.');
        if (n)
        {
          return `${src.substring(0, n)}_200x${src.substring(n)}`  
        }
        return src;
      }
    }
  });
  
  function checkCart(variantId, sellingPlanId) {
    vm.cart.busy = true;
    $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(data) {
            if (data.items && data.items.length) {
              // Detect an existing membership by its subscription selling plan (tags aren't
              // loaded on this raw /cart.js response). Club-branded bottles are one-time buys.
              const isInCart = data.items.find(item => item.selling_plan_allocation)

              if (isInCart) {
                vm.cart.fetchCartData();
                document.querySelector('.cart-link__bttn').click();
              } else {
                addItemToCart(variantId, 1, sellingPlanId)
            }
            } else {
              addItemToCart(variantId, 1, sellingPlanId)
            }
          },
          error: function() { vm.cart.busy = false; }
      });
  }

  function addItemToCart(variant_id, qty, sellingPlanId) {
    data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": sellingPlanId
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        vm.cart.fetchCartData();
        document.querySelector('.cart-link__bttn').click();
      },
      error: function() { vm.cart.busy = false; }
    });
  }

  // Explorer Club - Sign up (with price)
  $('.add_to_explorer').click(function(e){
    e.preventDefault();
    checkCart(49687212687588,7935426788);
  });

  // Founders Club - Sign up (with price)
  $('.add_to_cask').click(function(e){
    e.preventDefault();
    checkCart(49687312662756,7935459556);
  });

  // Waypoint Club - Sign up (with price)
  $('.add_to_waypoint').click(function(e){
    e.preventDefault();
    checkCart(49687457005796,7973798116);
  });

})